import api from '@api/Api';

export default {

    getEvent(id) {
        return api().get(`/events/${id}`);
    },

    getCustomers(id, params) {
        return api().get(`/events/${id}/customers`, { params: params });
    },

    updateEvent(id, params) {
        return api().put(`/events/${id}`, params);
    },

    deleteEvent(id) {
        return api().delete(`/events/${id}`);
    },

    updateEventProperty(id, propertyId, params) {
        return api().put(`/events/${id}/properties/${propertyId}`, params);
    },

    deleteEventProperty(id, propertyId) {
        return api().delete(`/events/${id}/properties/${propertyId}`);
    },

    createSegment(id) {
        return api().post(`/events/${id}/segment`);
    },

}
